export default __webpack_public_path__ + "static/media/Quienes_son_los_grandes_ganadores_del_transporte_en_Mexico.a4bb2d29.pdf";